import { useEffect } from 'react';
import { useFiles } from '@dev-streetbeat/chat/react';
import chatStore from 'shared/store/chatStore';

/**
 * Hook to handle file attachments by syncing SDK files to global state
 * This allows other components to access files without needing SDK context
 */
export const useHandleAttachments = () => {
  const { files: sdkFiles } = useFiles();
  const { setFiles } = chatStore();

  // Sync SDK files to global store
  useEffect(() => {
    setFiles(sdkFiles || []);
  }, [sdkFiles]);

  return {
    files: sdkFiles,
  };
};
